import FieldMixins from './mixins/field_mixin.js';

const Esignature = Vue.extend({
  mixins: [FieldMixins],

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               :disabledFieldLayout='disabledFieldLayout'
               ref='fieldView'>
      <template slot='content'>
        <div :class="(editing ? 'edit' : 'display') + '-content'">
          <button class="btn-default" readonly>
            <span>电子签字</span>
            <i class="slp-pencil-square"></i>
          </button>
        </div>
      </template>
    </FieldView>
  `
});

export default Esignature;
